<template>
  <div class="monitor-player">
    <div
      id="video-player"
      :style="`height: ${height}px; width: ${width}px`"
    ></div>

    <div
      v-show="false"
      v-if="isStop || loading"
      class="mask"
      @mousemove="hover"
    >
      <el-button
        v-if="isStop && isReady"
        circle
        icon="el-icon-caret-right"
        class="center-button"
        @click="readyPlay"
      >
      </el-button>

      <i
        v-else-if="isReady && loading"
        class="el-icon-loading center-button label"
      ></i>

      <div v-if="!cameras.length" style="color: #fff;">
        暂无可用设备
      </div>
    </div>

    <gimbal
      v-drag
      v-show="showGimbal"
      :token="token"
      :device="channel"
      :height="height"
      @close="showGimbal = false"
    ></gimbal>

    <replay-drawer
      :visible="showReplayDrawer"
      :device="channel"
      :token="token"
      :is-replay="isReplay"
      @replay="goReplay"
    ></replay-drawer>

    <!-- <transition name="fade">
      <div
        class="video-player__controls-wrap"
        v-show="showCtrl"
        :style="`top:${height}px;`"
        @mouseenter="enter"
        @mouseleave="out"
      >
        <process
          v-show="isReplay"
          :begin="replayFile.startTime"
          :end="replayFile.endTime"
          :time="time"
          @go-replay="goReplayTime"
        ></process>

        <div class="video-player__controls">
          <div class="video-player__group">
            <el-button
              v-if="isStop"
              type="text"
              class="video-button"
              icon="el-icon-caret-right"
              :disabled="!isReady"
              @click="play"
            ></el-button>
            <el-button v-else class="video-button" type="text" @click="stop">
              <svg-icon iconClass="stop"></svg-icon>
            </el-button>

            <el-tooltip
              popper-class="el-tooltip-content medium"
              effect="dark"
              placement="top"
            >
              <div slot="content">
                <span>当前播放: {{ isReplay ? '录像' : '监控' }}</span>
                <span v-if="isReplay"><br />点击切换</span>
              </div>
              <el-button
                type="text"
                class="video-button"
                @click="togglePlayType"
              >
                <svg-icon v-if="!isReplay" iconClass="monitoring"></svg-icon>
                <svg-icon
                  v-else
                  iconClass="replay"
                  style="width: 2rem;"
                ></svg-icon>
              </el-button>
            </el-tooltip>

            <el-button
              type="text"
              class="video-button label"
              @click="toggleReplayDrawer"
            >
              <span>录像文件</span>
            </el-button>
          </div>

          <div class="video-player__group">
            <el-button
              class="video-button label"
              type="text"
              :disabled="isStop"
              @click="showGimbal = !showGimbal"
            >
              云台
            </el-button>
            <el-button
              v-if="!isReplay && channels.length < 2"
              class="video-button label"
              type="text"
              :disabled="isStop"
              @click="switchHd"
            >
              {{ isHd ? '高清' : '标清' }}
            </el-button>
            <el-button
              v-if="hasSound"
              type="text"
              class="video-button"
              :disabled="isStop"
              @click="closeSound"
            >
              <svg-icon iconClass="sound-open" :disabled="!isReady"></svg-icon
            ></el-button>
            <el-button
              v-else
              type="text"
              class="video-button"
              :disabled="isStop"
              @click="openSound"
            >
              <svg-icon iconClass="sound-close" :disabled="!isReady"></svg-icon
            ></el-button>

            <el-button
              type="text"
              class="video-button"
              icon="el-icon-full-screen"
              :disabled="isStop"
              @click="fullScreen"
            >
            </el-button>
          </div>
        </div>
      </div>
    </transition> -->
  </div>
</template>

<script>
// import EZUIKit from '@/assets/js/ezuikit@2.js'
import EZUIKit from 'ezuikit-js/ezuikit.js'
import { formatDate } from '@/utlis/date'
// import Gimbal from './Gimbal'
// import Process from './process'
// import ReplayDrawer from './replayDrawer'
import { debounce } from '@/utlis'
// import sleep from '@/utlis/sleep'

export default {
  // components: { Gimbal, Process, ReplayDrawer },
  props: {
    channels: {
      type: Array,
      default() {
        return []
      }
    },
    token: String,
    width: Number,
    height: Number
  },
  data() {
    return {
      isReplay: false,
      showCtrl: true,
      loading: false,
      showGimbal: false, // 显示云台
      isStop: true,
      isReady: false,
      decoder: null,
      hasSound: false,
      isHd: false,
      timer: null, // 控制栏显示
      time: 0, // 当前回放时间
      replayFile: {}, // 回放文件信息
      processer: null, // 进度条轮训
      showReplayDrawer: false,
      selectedIndex: 0 // 多屏下当前选中屏幕
    }
  },
  computed: {
    channel() {
      return this.channels[this.selectedIndex]
    }
  },
  mounted() {
    window.onresize = debounce(() => {
      let isFull = this.checkFull()

      let width = isFull ? window.innerWidth : this.width
      let height = isFull ? window.innerHeight : this.height
      this.$nextTick(() => {
        if (this.decoder) {
          this.decoder.reSize(width, height)
        }
      })
    }, 200)

    this.$nextTick(() => {
      if (this.channels && this.channels.length) {
        this.initPlay({
          cb: () => {
            this.play()
          }
        })
      }
    })
  },
  beforeDestroy() {
    this.destroy()
    window.onresize = null
    window.GetSelectWndInfo = null
  },
  methods: {
    selectedChange(index) {
      this.selectedIndex = index
      const parent = document.getElementsByClassName('parent-wnd')[0]
      if (!parent) return
      for (let i in parent.children) {
        if (parent.children[i] && parent.children[i].setAttribute) {
          parent.children[i].setAttribute('class', '')
        }
      }

      const el = parent.children[index]
      if (el && el.setAttribute) {
        el.setAttribute('class', 'actived')
      }
    },
    async initPlay(params = {}) {
      this.loading = true
      this.isReady = false

      const { channel, begin, end, cb } = params
      const { token, width, height } = this

      if (this.decoder) {
        await this.destroy()
      }

      // 清空容器内残留的播放器 DOM，避免新旧播放器堆叠
      const container = document.getElementById('video-player')
      if (container) {
        container.innerHTML = ''
      }

      this.isReplay = Boolean(begin || end)
      const url = this.isReplay
        ? `${channel.replay}?begin=${begin}&end=${end}`
        : this.channels
            .map(c => {
              return this.isHd && c.channel === params.channel.channel
                ? c.hdLive
                : c.live
            })
            .join(',')
      if (this.isReplay) {
        this.processer = setInterval(this.setTime, 1000)
      }

      this.decoder = new EZUIKit.EZUIKitPlayer({
        // staticPath: '/js',
        id: 'video-player',
        autoplay: false,
        template: 'pcLive',
        muted: true,
        url,
        accessToken: token,
        // decoderPath: process.env.NODE_ENV === 'production' ? '/v3' : '',
        width,
        height,
        splitBasis: Math.ceil(Math.sqrt(this.channels.length)),
        handleInitSuccess: () => {
          this.loading = false
          this.isReady = true
          if (cb) cb()
        },
        onLoaded: () => {
          this.loading = false
          this.isReady = true
          if (cb) cb()
        },
        handleError: this.handleError,
        handleSuccess: this.handleSuccess
        // handleSelected: this.selectedChange
      })

      // setTimeout(() => {
      //   if (!this.channel) {
      //     this.decoder.loadingSet(0, { text: '暂无可用设备' })
      //   }
      // }, 5000)
    },
    handleSuccess() {
      this.isStop = false
      if (this.isReplay) {
        if (this.processer) {
          clearInterval(this.processer)
        }
        this.processer = setInterval(this.setTime, 1000)
      }
    },
    handleError() {
      this.$message.error({
        message: '加载监控失败，请稍后重试或联系管理员'
      })
      this.isReady = false
      if (this.isReplay) {
        if (this.processer) {
          clearInterval(this.processer)
        }
      }
    },
    readyPlay() {
      if (this.decoder && this.isReady) {
        this.play()
      }
    },
    async play() {
      if (this.decoder) {
        this.loading = true
        this.decoder && (await this.decoder.play())
      }
    },
    async destroy() {
      if (this.decoder) {
        const decoder = this.decoder
        this.decoder = null
        this.showGimbal = false
        this.isStop = true
        try {
          await decoder.stop()
        } catch (e) {
          // 销毁过程中的异常不阻塞重新初始化
        }
        try {
          await decoder.destroy()
        } catch (e) {
          // 同上
        }
        if (this.processer) {
          clearInterval(this.processer)
          this.processer = null
        }
      }
    },
    async stop() {
      this.showGimbal = false
      if (this.channels && this.decoder) {
        await this.decoder.stop()
        this.isStop = true
      }
      if (this.processer) {
        clearInterval(this.processer)
      }
    },
    closeSound() {
      const ret = this.decoder && this.decoder.closeSound()
      if (!ret) {
        this.hasSound = false
      } else {
        this.$message.error('关闭声音失败')
      }
    },
    openSound() {
      const ret = this.decoder && this.decoder.openSound()
      if (!ret) {
        this.hasSound = true
      } else {
        this.$message.error('开启声音失败')
      }
    },
    switchHd() {
      this.isHd = !this.isHd
      this.initPlay({
        isHd: true,
        channel: this.channel,
        cb: () => {
          this.decoder && this.decoder.play()
        }
      })
    },
    fullScreen() {
      let el = this.$el
      el.requestFullScreen
        ? el.requestFullScreen()
        : el.webkitRequestFullScreen
        ? el.webkitRequestFullScreen()
        : el.mozRequestFullScreen && el.mozRequestFullScreen()
      // this.$nextTick(() => {
      //   let { innerWidth: w, innerHeight: h } = window
      //   this.decoder.reSize(w, h)
      // })
    },
    hover() {
      // e.stopPropagation()
      // this.timer && clearInterval(this.timer)
      // if (!this.showCtrl) {
      //   this.showCtrl = true
      // }
      // this.timer = setTimeout(() => {
      //   this.showCtrl = false
      // }, 3000)
    },
    enter() {
      this.showCtrl = true
      this.timer && clearInterval(this.timer)
    },
    out() {
      // this.timer = setTimeout(() => {
      //   this.showCtrl = false
      // }, 3000)
    },
    toggleReplayDrawer() {
      this.showReplayDrawer = !this.showReplayDrawer
    },
    goReplay(file, time) {
      let bt = time || file.startTime
      const begin = formatDate(bt, 'YYYYMMDDHHmmss')
      const end = formatDate(file.endTime, 'YYYYMMDDHHmmss')
      this.isReady = false
      this.initPlay({
        channel: this.channel,
        begin,
        end,
        cb: () => {
          this.readyPlay()
          this.showReplayDrawer = false
          this.replayFile = file
          this.processer = setInterval(this.setTime, 1000)
        }
      })
    },
    async setTime() {
      try {
        this.time =
          (await this.decoder
            .getOSDTime(this.selectedIndex)
            .then(res => res.data)) * 1000
        if (this.loading) {
          this.loading = false
        }
      } catch {
        if (!this.loading) {
          this.loading = true
        }
      }
    },
    goReplayTime(time) {
      this.goReplay(this.replayFile, time)
    },
    togglePlayType() {
      if (this.isReplay) {
        this.isReplay = false
        this.initPlay({
          cb: () => {
            this.play()
          }
        })
      }
    },
    checkFull() {
      let isFull = false
      if (document.fullscreenEnabled || document.msFullscreenEnabled) {
        isFull = window.fullScreen || document.webkitIsFullScreen
        if (isFull === undefined) {
          isFull = false
        }
      }
      return isFull
    }
  },
  watch: {
    channels() {
      this.initPlay({
        cb: () => {
          this.play()
        }
      })
    }
  }
}
</script>

<style lang="scss">
.video-player__controls-wrap {
  height: 60px;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.video-player__controls {
  width: 100%;
  height: 60px;
  padding: 0 12px;
  // background-image: linear-gradient(to top, #000, rgba(0, 0, 0, 0));
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}
.video-player__group {
  display: flex;
  align-items: center;
}
.video-button {
  font-size: 24px;
  color: #fff;
  min-width: 54px !important;
  height: 32px;
  cursor: pointer;
  text-align: center;
  padding: 0;
}
.video-button.label {
  font-size: 1rem;
  line-height: 1rem;
}
.mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .center-button {
    font-size: 2rem;
  }
  .center-button.label {
    color: #fff;
  }
  .el-tooltip {
    font-size: 1rem;
  }
  &.actived {
    z-index: 0;
  }
}
.el-tooltip-content.medium {
  font-size: 14px;
}
.monitor-player {
  .actived:before {
    position: absolute;
    top: 0;
    left: 0;
    content: ' ';
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    border: 1px solid red;
  }
}
</style>
